import { getResellerIdFromRedux } from '@utils/common';
import http from 'httpConfig/http';

export const getCanaryUserFeatures = async () => {
    const { data } = await http.get(`${import.meta.env.VITE_APP_GET_API_URL}/feature-rollouts`);
    return data;
};
